import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "./productDetail.scss";
import "./productDetailModal/index";
$(function () {
  $(".product-simple-category__system-first-level").click(function () {
    var iconFlod = "product-simple-category__icon-fold";
    var iconUnFold = "product-simple-category__icon-unfold";
    var $el = $(this);
    var isCollapse = $el.find(".product-simple-category__icon-fold").length > 0;

    if (isCollapse) {
      $el.find(".product-simple-category__icon-fold").removeClass(iconFlod).addClass(iconUnFold);
      $el.find(".product-simple-category__lists--sub").show();
      $el.siblings("li").each(function () {
        var $siblingEl = $(this);
        $siblingEl.find(".product-simple-category__icon-unfold").removeClass(iconUnFold).addClass(iconFlod);
        $siblingEl.find(".product-simple-category__lists--sub").hide();
      });
    } else {
      $el.find(".product-simple-category__icon-unfold").removeClass(iconUnFold).addClass(iconFlod);
      $el.find(".product-simple-category__lists--sub").hide();
    }
  });
  $(".rich-content img").each(function () {
    $(this).removeAttr("width");
    $(this).removeAttr("height");
  });
});